import type { SiteTerminalParametersEntity } from "src/app/features/Site/types/SiteTerminalParametersEntity";
import type { SiteGroupTerminalForceParametersEntity } from "src/app/features/SiteGroup/types/SiteGroupTerminalForceParametersEntity";
import { extractNestedObject } from "../../../../../core/utils/utilFunctions";
import type { SiteGroupDto } from "../../types/SiteGroupDto";
import type { SiteGroupEntity } from "../../types/SiteGroupEntity";

export const SiteGroupEntityToDto = ({ dynamicProperties, ...rest }: Readonly<SiteGroupEntity>): SiteGroupDto => {
    const propValues = dynamicProperties?.dynamicPropertyValues?.map((propValue) => {
        const value = propValue.type === "TEXT" ? propValue.value || "" : propValue.value;

        return {
            id: propValue.id,
            key: propValue.key,
            type: propValue.type,
            label: propValue.label,
            pattern: propValue.pattern || "",
            readOnly: propValue.readOnly || false,
            value,
        };
    });

    const terminalParametersDto = extractNestedObject<SiteTerminalParametersEntity>(rest, "terminalParameters");
    const forceTerminalParametersDto = extractNestedObject<SiteGroupTerminalForceParametersEntity>(rest, "forceTerminalParameters");

    const cleanRest = Object.fromEntries(
        Object.entries(rest).filter(([key]) => !key.startsWith("terminalParameters") && !key.startsWith("forceTerminalParameters")),
    );

    const result = {
        ...cleanRest,
        terminalParameters: terminalParametersDto,
        forceTerminalParameters: forceTerminalParametersDto,
        dynamicProperties: {
            ...dynamicProperties,
            dynamicPropertyValues: propValues,
        },
    };

    return result;
};
